import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'
import router from './router'
import store from './store'
import GlobalMethods from './plugins/globalMethods'
//import Loading from 'vue-loading-overlay'
//import 'vue-loading-overlay/dist/vue-loading.css'
import './plugins/axios-bearer'
import '@/assets/styles/main.scss';
import ValidationPlugin from './plugins/validationPlugin';
import VMask from 'v-mask'
import Swal from 'sweetalert2'

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/es';

dayjs.extend(relativeTime);
dayjs.locale('es');

Vue.prototype.$dayjs = dayjs;

Vue.config.productionTip = false

//Vue.component('AppLoading', Loading)
Vue.use(GlobalMethods)
Vue.use(ValidationPlugin);
Vue.use(VMask)
Vue.prototype.$swal = Swal.mixin({
  buttonsStyling: false,
  customClass: {
    confirmButton: 'btn-confirm-global',
    cancelButton: 'btn-cancel-global',
    popup: 'popup-global'
  }
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
